import React, { useState } from "react";
import { Trans } from "react-i18next";
import { useParams } from "react-router-dom";

import { Card, CardList, InputGroup, Switch, Tag } from "@blueprintjs/core";

import {
  authenticatedGetFetch,
  authenticatedPostFetch,
} from "../../../utils/AuthenticatedFetch";
import Title from "../../Structure/logo";
import { GeneralInfo, ImageStatus } from "../Equipment";

function DeviceSettingBoolean(props) {
  return (
    <Card className="flexbox-center-large">
      <Tag>
        {props.setting.key} {props.setting.ordre}
      </Tag>
      <Trans>
        {"setting" +
          props?.general?.type +
          props.setting.key +
          props.setting.ordre}
      </Trans>
      <Switch
        checked={props.setting.value}
        onChange={(cb) => {
          authenticatedPostFetch(
            `/device/${props.serverId}/${props.deviceId}/setting`,
            {
              key: props.setting.key,
              ordre: props.setting.ordre,
              value: cb.target.checked,
              srv: props.serverId,
            },
            () => {
              props.update();
            }
          );
        }}
      />
    </Card>
  );
}

function DeviceSettingNumber(props) {
  return (
    <Card>
      <Tag>
        {props.key} {props.ordre}
      </Tag>
      <Trans>
        {props?.general?.type}
        {props.key}
        {props.ordre}
      </Trans>
      <InputGroup id="input_id" type="number" min={-1} value={props.value} />
    </Card>
  );
}

function DeviceSettingString(props) {
  return (
    <Card>
      <Tag>
        {props.key} {props.ordre}
      </Tag>
      <InputGroup id="input_id" value={props.value} />
    </Card>
  );
}

export default function DeviceSettings(props) {
  const { serverId } = useParams();
  const { deviceId } = useParams();
  const [device, setDevice] = useState({});
  const [settings, setSettings] = useState([]);

  React.useEffect(() => {
    authenticatedGetFetch(
      `/device/${serverId}/${deviceId}/state`,
      (definition) => setDevice(definition)
    );
    authenticatedGetFetch(
      `/device/${serverId}/${deviceId}/settings`,
      (settings) => setSettings(settings)
    );
  }, [deviceId, serverId]);

  function update() {
    setTimeout(() => {
      authenticatedGetFetch(
        `/device/${serverId}/${deviceId}/state`,
        (definition) => setDevice(definition)
      );
      authenticatedGetFetch(
        `/device/${serverId}/${deviceId}/settings`,
        (settings) => setSettings(settings)
      );
    }, 1000);
  }

  return (
    <div className="component-body">
      <Title icon="wrench" text={<Trans>device configuration</Trans>} />
      <div className="flexbox-center">
        <div>
          <GeneralInfo info={device?.general} size={2} />
          <ImageStatus eq={device} />
        </div>
        <div>
          <CardList bordered={true} compact={true} style={{ width: "100%" }}>
            {settings.map((setting) => {
              switch (setting.type) {
                case "boolean":
                  return (
                    <DeviceSettingBoolean
                      {...device}
                      setting={setting}
                      serverId={serverId}
                      deviceId={deviceId}
                      update={update}
                    />
                  );
                case "number":
                  return <DeviceSettingNumber {...device} setting={setting} />; // not tested
                case "string":
                  return <DeviceSettingString {...device} setting={setting} />; // not tested
                default:
                  return null;
              }
            })}
          </CardList>
        </div>
      </div>
    </div>
  );
}
